import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20moody%20crimson%20and%20charcoal%20smoke%20swirling%20over%20a%20dark%20textured%20backdrop%2C%20dramatic%20cinematic%20editorial%20lighting%2C%20subtle%20film%20grain%2C%20soft%20bokeh%20highlights%2C%20deep%20shadow%20depth%2C%20elegant%20minimal%20composition%2C%20high%20contrast%2C%20no%20text&width=1800&height=1050&seq=hlz-hero-01&orientation=landscape"
          alt="黑料照片 归档主视觉"
          title="黑料照片合集 主视觉"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/85"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-[1200px] flex-col items-center px-4 py-16 text-center md:px-6 md:py-24 lg:py-28">
        <span className="animate-rise inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur">
          <i className="ri-folder-shield-2-line text-sm text-accent-400"></i>
          人物 · 事件 双维度分类整理，站内一键翻到底
        </span>

        <h2 className="animate-rise mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
          黑料照片 <span className="text-accent-400">全收录</span>
          <br className="hidden md:block" />
          高清原图 · 打包合集一站翻完
        </h2>

        <p className="animate-rise mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          站内汇总全网热门事件的黑料照片与原图合集，按人物、事件分类整理，持续更新最新收录内容。
          想看某位人物或某起事件的全记录，直接从对应合集入口翻到底即可。
        </p>

        <div className="animate-rise mt-8 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="#latest"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-flashlight-line text-base"></i>
            浏览最新收录
          </a>
          <a
            href="#packages"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            <i className="ri-folder-zip-line text-base"></i>
            查看打包合集
          </a>
        </div>

        <div className="mt-12 grid w-full grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 md:mt-16 md:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-1 bg-foreground-950/30 px-4 py-5 backdrop-blur">
              <span className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-1 text-sm font-medium text-accent-400">{stat.unit}</span>
              </span>
              <span className="text-xs text-background-300 md:text-sm">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}